<template>
    <rkm-area
        type="fieldset"
        title="Residentes"
    >

        <rkm-row v-if="data.model">
            <rkm-col cols="12">

                <rkm-table
                    :items="itens"
                    :fields="fields"
                    sort-by="nome"
                    hide-filters
                >

                    <template v-slot:cell(nome)="row">
                        <rkm-button
                            class="mr-2"
                            color="secondary"
                            small
                            v-rkm-popover.hover.left="{
                                title: 'Dados cadastrais',
                                html: true,
                                content:
                                    '<b>CNS:</b> ' + (formatCns(row.item.cns) || '') + '<br/>' +
                                    '<b>Nome da mãe:</b> ' + row.item.nomeMae + '<br/>'
                            }"
                        >
                            <rkm-icon icon="user" />
                        </rkm-button>

                        <span>
                            {{ row.item.nome }}

                            <template v-if="row.item.nomeSocial">
                                <strong>({{ row.item.nomeSocial }})</strong>
                            </template>
                        </span>
                    </template>

                    <template v-slot:cell(actions)="{ item }">

                        <rkm-button
                            color="primary"
                            small
                            title="Visualizar"
                            @click.stop="$router.push({ name: 'atencao-basica-cadastro-domiciliar-edit', params: { id: item.domicilioId } })"
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Mixins.
import { formats } from '@/mixins'

export default {
    data() {
        return {
            items: [],
        }
    },
    computed: {
        fields() {
            const fields = [
                {
                    key: "nome",
                    label: "Nome",
                    sortable: true
                },
                {
                    key: "prontuario",
                    label: "Prontuário",
                    sortable: true,
                    class: 'col-min text-center'
                },
                {
                    key: "dataNascimento",
                    label: "Data de nascimento",
                    sortable: true,
                    class: 'col-min text-center'
                },
                {
                    key: "parentesco",
                    label: "Parentesco com o responsável familiar",
                    sortable: true
                }
            ]

            return fields
        },
        itens() {
            return this.data.form.residentes ?? []
        }
    },
    mixins: [ formats ],
    props: {
        data: { type: Object, required: false, },
    }
}
</script>